<template>
  <Dialog :commonDialog="bDialog" :dialogWidth="dialogWidth">
    <template v-slot:title>
      <v-layout>
        <v-flex> Manage house(s)</v-flex>
        <v-flex class="text-right">
          <v-btn
            depressed
            small
            class="mx-4 white--text"
            color="cyan"
            v-on:click="createHouseType"
          >
            <span class="font-size-16 font-weight-600">Add House</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:body>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll custom-box-top-inner-shadow"
        style="max-height: 90vh; position: relative"
      >
        <v-form
          ref="ticketCollecttionForm"
          lazy-validation
          v-on:submit.stop.prevent="updateProductBrand"
        >
          <v-container class="py-0">
            <v-row class="py-0">
              <v-col md="12" class="py-0">
                <table class="width-100">
                  <tbody v-for="(type, index) in house" :key="index">
                    <!-- Row 1: Service name and buttons -->
                    <tr>
                      <td>
                        <v-text-field
                          v-model="type.value"
                          dense
                          filled
                          placeholder="House Type"
                          solo
                          flat
                          class="px-4 py-2"
                          hide-details
                          :disabled="pageLoading"
                          :loading="pageLoading"
                          color="cyan"
                        />
                        <span
                          v-if="
                            type?.id &&
                            type?.service_variables_house_count !== '0'
                          "
                          class="px-4 py-2 red--text font-weight-400"
                          >This House is already used in other
                          transactions</span
                        >
                      </td>

                      <!-- Delete icon -->
                      <td width="50" v-if="house.length > 1">
                        <v-tooltip top content-class="custom-top-tooltip">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              :disabled="
                                type?.id &&
                                type?.service_variables_house_count !== '0'
                              "
                              @click="deleteProductBrand(index)"
                              color="deep-orange"
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                          <span>Click here to delete</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </perfect-scrollbar>
    </template>
    <template v-slot:action>
      <v-btn
        depressed
        :disabled="pageLoading"
        :loading="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button white--text"
        color="cyan"
        v-on:click="updateHouseType"
      >
        Save
      </v-btn>
      <v-btn
        depressed
        :disabled="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="$emit('close-dialog', true)"
      >
        Close
      </v-btn>
    </template>
  </Dialog>
</template>
<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import { PATCH } from "@/core/services/store/request.module";
// import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import ValidationMixin from "@/core/plugins/validation-mixin";
import CommonMixin from "@/core/plugins/common-mixin";
import { cloneDeep } from "lodash";

export default {
  mixins: [ValidationMixin, CommonMixin],
  props: {
    bDialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    house: {
      type: Array,
      default: () => {
        return new Array();
      },
    },
    /* existCategory: {
        type: String,
        default: null,
      }, */
  },
  watch: {
    house: {
      deep: true,
      immediate: true,
      handler(param) {
        this.houseList = cloneDeep(param);
      },
    },
  },
  data: () => {
    return {
      pageLoading: false,
      viewAddButton: [],
      houseList: [{}],
    };
  },
  methods: {
    showAddFields(index) {
      this.$set(this.viewAddButton, index, !this.viewAddButton[index]);
    },
    updateHouseType() {
      const _this = this;
      // const formErrors = _this.validateForm(_this.$refs.ticketCollecttionForm);

      // if (formErrors.length) {
      //   for (let i = 0; i < formErrors.length; i++) {
      //     ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
      //     _this.pageLoading = false;
      //   }
      //   // return false;
      // }
      _this.pageLoading = true;
      _this.$store;
      _this.$store;
      _this.$store
        .dispatch(PATCH, {
          url: "setting/house-types",
          data: { service_value: _this.houseList },
        })
        .then(() => {
          _this.$emit("close-dialog", true);
          _this.$emit("get-house-type", true);
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    createHouseType() {
      this.house.push({});
    },
    deleteProductBrand(index) {
      if (this.house.length > 1) {
        this.house.splice(index, 1);
      }
    },
  },
  components: {
    Dialog,
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
    },
  },
};
</script>
